import { BrokerAlertConfig } from 'gql/generated.graphql';

export const getAlertByIdDocumentToFormData = (
  alert?: BrokerAlertConfig | null
) => {
  const { filter, name } = alert || {};
  return filter
    ? {
        name,
        place: filter.locationFilter,
        radius: filter.locationFilter?.radiusToSearchInMiles,
        min: filter.priceRange?.min,
        max: filter.priceRange?.max,
        buildingTypes: filter.buildingTypes,
        numberOfBedrooms: filter.unitNumberOfBedrooms?.min,
        numberOfBathrooms: filter.unitNumberOfBathrooms?.min,
        numberOfUnits: {
          min: filter.unitNumberOfUnits?.min,
          max: filter.unitNumberOfUnits?.max,
        },
        marketAreaIds: filter.marketAreaIds,
        featuresAndAmenities: filter.amenityIds,
        constructionDate: {
          startDate: filter.constructionDateRange?.startDate,
          endDate: filter.constructionDateRange?.endDate,
        },
        projectStatus: filter.projectStatuses,
        yearBuilt: {
          min: filter.yearBuildRange?.min,
          max: filter.yearBuildRange?.max,
        },
      }
    : {};
};
